import type { MetricRegistryMeta, TileMeta } from '../types';

export const hasTileQuery = (meta?: TileMeta | null): boolean =>
  Boolean(meta?.query?.trim());

export const getMetricInfoFields = (registry?: MetricRegistryMeta | null) => ({
  metricKey: registry?.id?.trim() || '',
  businessDefinition: registry?.business_definition?.trim() || '',
  catalogId: registry?.catalog?.catalog_id?.trim() || '',
});

export const hasMetricInfoFields = (registry?: MetricRegistryMeta | null): boolean => {
  const fields = getMetricInfoFields(registry);
  return Boolean(fields.metricKey || fields.businessDefinition || fields.catalogId);
};

/** Reserve title padding when query copy and/or MetricInfo chrome may render. */
export const hasTileMetaChrome = (meta?: TileMeta | null): boolean =>
  hasTileQuery(meta) || hasMetricInfoFields(meta?.registry);

export const tileMetaTitlePad = (meta?: TileMeta | null, fallback = 0): number =>
  hasTileMetaChrome(meta) ? 7 : fallback;
